import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Same-origin: the httpOnly session cookie is sent automatically for these links.
export const fileUrl = (fileId) => `${API}/files/${fileId}/download`;
export const receiptUrl = (appId) => `${API}/applications/${appId}/receipt`;
